import React from "react";
import { useNavigate } from "react-router-dom";
import countries from "../../constant/countries";

const PinkTickCard = () => {
  const navigate = useNavigate();

  const handleJoin = () => {
    const allCountryNames = countries.map((c) => c.name);
    navigate("/pinkhelp/advertising-portal/selected", {
      state: { selectedCountries: allCountryNames },
    });
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 max-w-md mx-auto">
      <h2 className="text-xl font-bold text-pink-600 mb-2">
        Become PINK TICK Verified
      </h2>
      <p className="text-gray-700 mb-4">
        For only <span className="font-semibold">$50.00/month</span>, you can
        become a PINK TICK verified partner with world-class marketing and SEO
        benefits.
      </p>
      <button
        className="bg-pink-600 text-white py-2 px-4 w-full rounded hover:bg-pink-700 transition"
        onClick={handleJoin}
      >
        Join Now
      </button>
    </div>
  );
};

export default PinkTickCard;
